var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpAndSupportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.666672C4.66667 0.666672 2 3.33334 2 6.66667V11.3333C2 11.8638 2.21071 12.3725 2.58579 12.7476C2.96086 13.1226 3.46957 13.3333 4 13.3333H6V8H3.33333V6.66667C3.33333 5.42899 3.825 4.24201 4.70017 3.36684C5.57534 2.49167 6.76232 2.00001 8 2.00001C9.23768 2.00001 10.4247 2.49167 11.2998 3.36684C12.175 4.24201 12.6667 5.42899 12.6667 6.66667V8H10V13.3333H12.6667V14H8V15.3333H12C12.5304 15.3333 13.0391 15.1226 13.4142 14.7476C13.7893 14.3725 14 13.8638 14 13.3333V6.66667C14 3.33334 11.3133 0.666672 8 0.666672Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpAndSupportIcon);
export default __webpack_public_path__ + "static/media/help-and-support-icon.a699f7a2d6b81e3229ae06c8c38cc3b8.svg";
export { ForwardRef as ReactComponent };